module.exports = __webpack_public_path__ + "img/download-icon.0a05addc.svg";